import * as Sentry from "@sentry/react";
import React from "react";
import { createRoot } from "react-dom/client";

// Import dark theme before App
import "../styles/dark-theme.scss";
import "../sass/style.scss";
import "../static/styles.css";  // Import the static navigation styles
import App from "./App";

Sentry.init({
  dsn: window.SENTRY_DSN,
  release: window.COMMIT_SHA,
});

const container = document.getElementById("react-root"); // or whatever your root element ID is

if (container) {
  const root = createRoot(container);
  root.render(
    <Sentry.ErrorBoundary>
        <App />
      {/* <React.StrictMode> */}
      {/*   <App /> */}
      {/* </React.StrictMode> */}
    </Sentry.ErrorBoundary>,
  );
}
